import { Typography, Box } from "@mui/material";

export default function MenuNewBadge({ count = 0, size = 0, reversed = false }: { count?: number; size?: number, reversed?: boolean }) {
    return (
        <Box
            className={`rounded-lg flex justify-center items-center`}
            sx={{
                bgcolor: !reversed ? 'orangered' : '#ffffff',
                width: Number(size) > 0 ? `${size}px` : '20px',
                height: Number(size) > 0 ? `${size}px` : '20px',
            }}

        >
            <Typography variant="caption" style={{ color: !reversed ? 'white' : 'orangered', fontWeight: 'bold' }}>
                {!!count ? `${Number(count) > 9 ? `9+` : count}` : 'N'}
            </Typography>
        </Box>
    )
}